module.exports = __webpack_public_path__ + "static/media/bg4.7c7b2f89.png";